import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, CardHeader, Grid, Typography, Button } from '@material-ui/core';
import ErrorHandling from '../../../components/ErrorHandling/ErrorHandling';
import { useDispatch, useSelector } from 'react-redux';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { FormattedInputs } from '../../../components/InputControls';
import { actionGetDonation } from 'actions';

const { DonationHeading, DonationDetails, ShowDonationsSections, DonationProductID,
    InvalidDOnationAmount, DonationOtherAmountButtonText, Currency } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {},
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    itemsmarginR: {
        'margin-right': '10px',
        display: 'block !important'
    },
    donateBtn: {
        justifyContent: 'center',
        display: 'flex',
        marginTop: '10px'
    },
    errorFont: {
        color: 'red'
    }
}));


const Donations = props => {

    const donations = useSelector(state => state.reducerDonation);
    const donation = useSelector(state => state.reducerShopCart.donation);

    const [showOthers, setshowOthers] = React.useState(false);
    const [donationPrice, setdonationPrice] = React.useState(0);
    const [productName, setproductName] = React.useState('');
    const [checkexist, setcheckexist] = React.useState(false);
    const [validateMsg, setvalidateMsg] = useState('');

    const [errormsg, seterrormsg] = useState("");
    const classes = useStyles();
    const dispatch = useDispatch();

    useEffect(() => {
        if (DonationProductID !== undefined && (donations.donations.length === 0 || donations.donations.length === undefined))
            actionGetDonation(dispatch, DonationProductID, 'donation');
    }, []);


    useEffect(() => {
        if (donation.isdonationApplied === false) {
            setcheckexist(false);
            setdonationPrice(0);
        }
    }, [donation.isdonationApplied]);

    const openerrorpopup = () => {
        return (errormsg != "")
    }

    const errorcancelhandle = () => {

        seterrormsg('');
    }


    const ApplyDonation = () => {

        if (donationPrice === "" || donationPrice === 0 || donationPrice < 0.1) {
            Validated(false);
            return;
        }

        if (validateMsg !== '' && validateMsg.length > 0) {
            return;
        }

        props.ApplyDonation(DonationProductID, productName, donationPrice, showOthers ? true : false);
    }

    const Validated = (val) => {
        if (val)
            setvalidateMsg('');
        else
            setvalidateMsg(InvalidDOnationAmount);
    }

    const handleChange = (event) => {

        setcheckexist(true);

        if (event.target.value === "Other") {
            setshowOthers(true)
            setdonationPrice('');
        }
        else {
            setshowOthers(false);
            setdonationPrice(event.target.value);
            setproductName(event.target.name);
            setvalidateMsg('');
        }
    };

    const handleOtherPrice = (event) => {
        setdonationPrice(event.target.value);
        setproductName(event.target.name);

        if (donation && donation.isdonationApplied && donation.otherAmount) {
            setshowOthers(true);
            setcheckexist(true);
        }
    }

    return (
        <Grid>
            <ErrorHandling msg={errormsg} open={openerrorpopup()} handleclose={errorcancelhandle} />

            {ShowDonationsSections ?

                <Grid item xs={12}>
                    <Card>
                        <CardHeader className={classes.tourheaderbox}
                            title={DonationHeading}
                            titleTypographyProps={{ color: "inherit" }}
                        />
                        <CardContent>
                            <Grid container>
                                <Typography style={{ marginTop: "10px" }}>
                                    {DonationDetails}
                                </Typography>
                            </Grid>
                            <Grid container >
                                <Typography style={{ marginTop: "10px", color: "Red" }}>
                                    {validateMsg}
                                </Typography>
                            </Grid>
                            <Grid container alignItems="center" item xs={12} ms={12} lg={12}>

                                <RadioGroup aria-label="donations" value={checkexist ? showOthers ? 'Other' : donationPrice : donation.isdonationApplied ? donation.otherAmount ? 'Other' : donation.price : ''} name="donations" >

                                    {donations.donations !== "nocontent" && donations.donations.length > 0 ?
                                        donations.donations.map((dona, i) => {

                                            return dona.Price > 0 ?

                                                dona.hasOwnProperty("MaxPrice") ?

                                                    <div className={'MuiFormControlLabel-root'} key={donations}>

                                                        <FormControlLabel key={i} value="Other" control={<Radio />} label={DonationOtherAmountButtonText} onChange={handleChange} />

                                                        {showOthers || (checkexist === false && donation.otherAmount) ?

                                                            <FormattedInputs
                                                                donaValue={checkexist ? donationPrice : donation.isdonationApplied ? donation.price : donationPrice}
                                                                minValue={dona.Price}
                                                                maxValue={dona.MaxPrice}
                                                                productName={dona.ProductName}
                                                                handleOtherPrice={handleOtherPrice}
                                                                Validated={Validated}
                                                                keyVal={i}
                                                            ></FormattedInputs> : null}

                                                    </div>
                                                    :

                                                    <FormControlLabel key={i} value={dona.Price.toString()} name={dona.ProductName} control={<Radio />} label={Currency + '' + dona.Price} onChange={handleChange} />

                                                : null
                                        }) : null}

                                </RadioGroup>
                            </Grid>
                            <div className={classes.donateBtn}>
                                <Button onClick={ApplyDonation} disabled={donation.isdonationApplied} variant="contained" size="large" color="primary" >
                                    Donate
                                </Button>
                            </div>
                        </CardContent>
                    </Card>
                </Grid>
                : null}

        </Grid>
    );
};

export default Donations;
